<template>
  <div class="dialog-container wt-dialog-container">
    <div v-loading="isUserWechatDetailLoading">
      <wt-detail-form-section ref="formSection" :detail-form-data.sync="detailFormData" :detail-form.sync="detailForm" />
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'UserAddPage',
  isAutoComponent: true,
  data() {
    return {
      formAddUrl: '/modules/userWechat/adminUserAdd',
      detailFormButtons: {
        title: '新增用户',
        elements: [{ name: '提交', key: 'ADD', action: 'ADD', hidden: false, className: 'primary' },
          { name: '取消', key: 'CLOSE', action: 'CLOSE' }]
      },
      detailForm: {
        title: '新增用户',
        elements: [
          { name: '姓名',
            key: 'name',
            type: 'text',
            required: true,
            disabled: false,
            rules: [
              { min: 1, max: 20, message: '姓名长度不能超过20', trigger: 'blur' }
            ] },
          { name: '手机号',
            key: 'phone',
            type: 'text',
            required: true,
            disabled: false,
            rules: [
              { min: 11, max: 11, message: '手机号格式不正确', trigger: 'blur' },
              { pattern: this.$wtValidator.ValidatorPhonePattern, message: '手机号格式不正确', trigger: 'blur' }
            ] },
          { name: '性别',
            key: 'gender',
            type: 'select',
            required: true,
            disabled: false,
            data: [
              { label: '男', value: 1 },
              { label: '女', value: 2 }
            ]
          },
          { name: '小区',
            key: 'communityId',
            type: 'select',
            required: true,
            disabled: false,
            data: [] },
          { name: '门牌号',
            key: 'doorplate',
            type: 'text',
            required: true,
            disabled: false }]
      }
    }
  },
  created() {
    this.communityNoPageList()
    this.$store.dispatch('appendBreadcrumb', { meta: { title: '用户新增' }})
  },
  methods: {
    /*  ------------------------- 按钮  -------------------------  */
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
        this.$store.dispatch('removeBreadcrumb')
      } else if (item.action === 'ADD') {
        this.onAdd()
      }
    },
    onAdd() {
      const that = this
      this.$wtUtil.validateDetailFormsAndConfirm(this, '是否提交').then(() => {
        that.requestUserWechatAdd()
      }).catch(() => {
      })
    },
    requestUserWechatAdd() {
      const that = this
      this.$wtUtil.postFormData({
        url: this.formAddUrl,
        formData: this.detailFormData,
        isLoading: this.isSubmitLoading
      }).then(resp => {
        that.$message({ message: '保存成功', type: 'success' })
        that.$emit('on-dialog-action', 'close')
        this.$store.dispatch('removeBreadcrumb')
        this.$emit('on-dialog-action', 'refresh')
      })
    },
    // 社区
    communityNoPageList() {
      this.$api.community.communityNoPageList().then(res => {
        for (const item of res.data) {
          item.label = item.name
          item.value = item.id
        }
        this.detailForm.elements[3].data = res.data
      })
    }
  },
  computed: {
    ...mapState({
      isUserWechatDetailLoading: state => state.userWechat.isUserWechatDetailLoading,
      detailFormData: state => state.userWechat.generalUserDetailData
    })
  }
}
</script>

<style>
</style>
